import React from 'react'
import {
  Grid,  Typography } from '@mui/material'
import { map } from '@/utils/lodash'

const InputSectionForm = ({ inputFields, renderInputFields  }) => (
  <>
    <Grid container>
      <Grid size={12}>
        <Typography variant="h6">Input</Typography>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={1}>
      {map(inputFields, (field) => renderInputFields(false)(field))}
    </Grid>
  </>
)

export default InputSectionForm
